/**
 * CSV to Json
 *
 * @param   string
 * @return  json
 */
/* eslint-disable */
const csv2json = function csv2json(str, sep) {
  console.debug('*** Start *** csv2json')
  var separator = sep
  var columnSize = str.split(/\r\n|\r|\n/)[0].split(separator).length
  var chars = Array.from(str.replace(/\r\n|\r|\n/g, '\n'))
  var csvList = []
  var list = []
  var queteOpenFlg = false
  var buf = ''
  for (var i = 0; i < chars.length; i++) {
    // console.log(columnSize)
    if (chars[i] == '"') {
      queteOpenFlg = queteOpenFlg == false
    } else {
      if ((chars[i] == separator || chars[i] == '\n') && !queteOpenFlg) {
        list.push(buf)
        buf = ''
        if (list.length == columnSize) {
          csvList.push(list)
          list = []
        }
      } else {
        buf += chars[i]
      }
    }
  }
  // console.log(csvList[0][0])
  var csv = {}
  csv.dataList = []
  for (var i = 0; i < csvList.length; i++) {
    if (i == 0) {
      csv.header = csvList[i]
    } else {
      csv.dataList.push(csvList[i])
    }
  }
  console.debug('*** End *** csv2json: ' + csv)
  return csv
}

export default csv2json



// WEBPACK FOOTER //
// ./src/functions/csv2json.js